<template>
  <v-container>
    <PageHeader style="position: relative;" subtitle="Manage monitoring locations and assign data sources to them." no-padding />
    <v-card>
      <v-divider />
      <v-layout row wrap class="pa-3 card-bg-2">
        <v-hover>
          <v-card @click="showEmptyLocations()" slot-scope="{ hover }" :class="[ hover ? 'elevation-3' : 'elevation-1' ]" class="clickable mr-3">
            <v-card-text class="card-bg-1">
              <div class="secondary--text">
                Empty Monitoring Locations
                <Tooltip color="primary" small text="These locations are not shown in the side menu because they have no data types assigned." />
              </div>
              <div class="headline" :class="[ emptyLocationsLength > 0 ? 'error--text' : 'success--text']">
                {{ emptyLocationsLength }}
              </div>
            </v-card-text>
          </v-card>
        </v-hover>
        <v-hover>
          <v-card @click="showUnassigned()" slot-scope="{ hover }" :class="[ hover ? 'elevation-3' : 'elevation-1' ]" class="clickable">
            <v-card-text class="card-bg-1">
              <div class="secondary--text">
                Unassigned Data Sources
                <Tooltip color="primary" small text="To view data for these data sources, please assign them to a location. <br/> Only one type of data type can be present at one location" />
              </div>
              <div class="headline" :class="[ unassignedLength > 0 ? 'error--text' : 'success--text']">
                {{ unassignedLength }}
              </div>
            </v-card-text>
          </v-card>
        </v-hover>
      </v-layout>
      <v-divider />
      <v-tabs dark v-model="currentViewType" active-class="tabs-active-tab" slider-color="info">
        <v-tab v-for="(viewType, index) in VIEW_TYPES" :href="`#${viewType.value}`" :key="`viewType-${index}`">
          <v-icon class="mr-2">{{ viewType.icon }}</v-icon>
          {{ viewType.text }}
        </v-tab>
      </v-tabs>
      <ViewMonitoringFeatures ref="viewMonitoringFeatures" v-show="currentViewType == VIEW_TYPES.monitoringFeatures.value" :search="search" />
      <ViewDataSources ref="viewDataSources" v-show="currentViewType == VIEW_TYPES.dataSources.value" :unassignedLength="unassignedLength" :search="search" />
    </v-card>
  </v-container>
</template>

<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'

  import ViewMonitoringFeatures from './ViewMonitoringFeatures'
  import ViewDataSources from './ViewDataSources'

  const dataSources = createNamespacedHelpers('datasource')
  const monitoringFeatures = createNamespacedHelpers('monitoringfeature')
  const navigation = createNamespacedHelpers('navigation')

  import {
    SOURCE_TYPES,
  } from '@/store/MonitoringFeature/monitoringfeature'

  const VIEW_TYPES = {
    monitoringFeatures: {
      text: 'Monitoring Locations',
      value: 'monitoring_locations',
      icon: 'satellite',
    },
    dataSources: {
      text: 'Data Sources',
      value: 'data_sources',
      icon: 'router',
    },
  }

  export default {
    components: {
      ViewMonitoringFeatures,
      ViewDataSources,
    },
    data: () => ({
      SOURCE_TYPES,
      VIEW_TYPES,
      currentViewType: VIEW_TYPES.monitoringFeatures.value,
      search: '',
    }),
    computed: {
      ...monitoringFeatures.mapGetters([
        'monitoringFeatures',
      ]),
      ...dataSources.mapGetters(['dataSources']),
      ...navigation.mapGetters(['searchableLocationItems']),
      unassignedDataSources() {
        let index = {}
        Object.values(SOURCE_TYPES).forEach(sourceType => {
          let dataSources = this.dataSources[sourceType]
          if (!dataSources) return
          index[sourceType] = dataSources.filter(ds => !ds.MonitoringFeatureId)
        })
        return index
      },
      emptyLocationsLength() {
        return this.searchableLocationItems.filter(sli => sli.dataTypes.length === 0).length
      },
      unassignedLength() {
        let dataSources = Object.values(this.unassignedDataSources)
        if (!dataSources) return 0
        return dataSources.flatten().length
      },
    },
    methods: {
      showEmptyLocations() {
        this.currentViewType = VIEW_TYPES.monitoringFeatures.value
        this.$refs.viewMonitoringFeatures.showEmpty()
      },
      showUnassigned() {
        this.currentViewType = VIEW_TYPES.dataSources.value
        this.$refs.viewDataSources.showUnassigned()
      },
    },
  }
</script>

<style>

</style>